import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'HighlightText',
})(
  (
    { aspectRatio, brandColors, breakpoints, typography, type, spacing },
    props
  ) => ({
    container: {
      backgroundColor: darkOrLightStyle(props)(
        brandColors.tintsHeroBlue10,
        brandColors.tintsOffWhite60
      ),
    },
    wrapper: {
      width: '100%',
      display: 'flex',
      gap: spacing(2),
      flexDirection: 'column',
      flexWrap: 'nowrap',
      [breakpoints.up('sm')]: {
        gap: spacing(3),
      },
      [breakpoints.up('md')]: {
        flexDirection: 'row-reverse',
      },
      [breakpoints.up('lg')]: {
        gap: spacing(4),
      },
      '&.reverseRow': {
        [breakpoints.up('md')]: {
          flexDirection: 'row',
        },
      },
      '&.reverseColumn': {
        [breakpoints.down('md')]: {
          flexDirection: 'column-reverse',
        },
      },
    },
    imageContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 0,
    },
    image: {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
      aspectRatio: aspectRatio['16/9'],
      borderRadius: typography.pxToRem(16),
    },
    textContent: {
      padding: 0,
      [breakpoints.up('sm')]: {
        paddingTop: 0,
      },
      [breakpoints.up('md')]: {
        paddingTop: 0,
      },
    },
    subhead: {
      ...type['18_regular'],
      [breakpoints.up('sm')]: { ...type['20_regular'] },
      [breakpoints.up('xl')]: { ...type['24_regular'] },
    },
  })
);

export default useStyles;
